/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfGetPortalForEditOutput } from "../models/AjaxResponseOfGetPortalForEditOutput";
import type { AjaxResponseOfListOfPortalDto } from "../models/AjaxResponseOfListOfPortalDto";
import type { AjaxResponseOfPagedResultDtoOfGetPortalForViewDto } from "../models/AjaxResponseOfPagedResultDtoOfGetPortalForViewDto";
import type { AjaxResponseOfPortalAuditResult } from "../models/AjaxResponseOfPortalAuditResult";
import type { AjaxResponseOfPortalDto } from "../models/AjaxResponseOfPortalDto";
import type { CreateOrEditPortalDto } from "../models/CreateOrEditPortalDto";

import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";

export class PortalsAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns AjaxResponseOfPortalAuditResult
   * @throws ApiError
   */
  public checkInconsistency({
    portalCode,
    vendorId,
  }: {
    portalCode:
      | "WebMotorsPortalName"
      | "AutolinePortalName"
      | "CompreCarPortalName"
      | "FacebookPortalName"
      | "iCarrosPortalName"
      | "MercadoLivrePortalName"
      | "MeuCarroNovoPortalName"
      | "MobiAutoPortalName"
      | "OlxPortalName"
      | "ResourcesPortalName"
      | "MotorMePortalName"
      | "UsadosbrPortalName"
      | "SyncCmsPortalName"
      | "CarroSP"
      | "ChavesNaMao"
      | "Platforms"
      | "SoCarrao"
      | "RepasseAutos"
      | "Youtube"
      | "Cockpit"
      | "NaPistaLeads"
      | "SalaoDoCarro"
      | "CompreCarPortalLeads"
      | "ClickAutos"
      | "NetMotors"
      | "AutoShopping"
      | "ChavesNaMaoPortalLeads"
      | "ClickAutosPortalLeads"
      | "Premium";
    vendorId?: number;
  }): CancelablePromise<AjaxResponseOfPortalAuditResult> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/portals/check-inconsistency",
      query: {
        portalCode: portalCode,
        vendorId: vendorId,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public createOrEdit({
    requestBody,
  }: {
    requestBody?: CreateOrEditPortalDto;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/portals",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public delete({ id }: { id?: number }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/portals",
      query: {
        id: id,
      },
    });
  }

  /**
   * @returns AjaxResponseOfPagedResultDtoOfGetPortalForViewDto
   * @throws ApiError
   */
  public getAll({
    filter,
    nameFilter,
    credentialVendorId,
    sorting,
    skipCount,
    maxResultCount,
  }: {
    filter?: string;
    nameFilter?: string;
    credentialVendorId?: number;
    sorting?: string;
    skipCount?: number;
    maxResultCount?: number;
  }): CancelablePromise<AjaxResponseOfPagedResultDtoOfGetPortalForViewDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/portals",
      query: {
        filter: filter,
        nameFilter: nameFilter,
        credentialVendorId: credentialVendorId,
        sorting: sorting,
        skipCount: skipCount,
        maxResultCount: maxResultCount,
      },
    });
  }

  /**
   * @returns AjaxResponseOfListOfPortalDto
   * @throws ApiError
   */
  public getAllList(): CancelablePromise<AjaxResponseOfListOfPortalDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/portals/get-all-list",
    });
  }

  /**
   * @returns AjaxResponseOfPortalDto
   * @throws ApiError
   */
  public getPortal({
    id,
  }: {
    id: number;
  }): CancelablePromise<AjaxResponseOfPortalDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/portals/{id}",
      path: {
        id: id,
      },
    });
  }

  /**
   * @returns AjaxResponseOfGetPortalForEditOutput
   * @throws ApiError
   */
  public getPortalForEdit({
    id,
  }: {
    id?: number;
  }): CancelablePromise<AjaxResponseOfGetPortalForEditOutput> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/portals/get-portal-for-edit",
      query: {
        id: id,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public removeInconsistency({
    portalCode,
    vendorId,
  }: {
    portalCode:
      | "WebMotorsPortalName"
      | "AutolinePortalName"
      | "CompreCarPortalName"
      | "FacebookPortalName"
      | "iCarrosPortalName"
      | "MercadoLivrePortalName"
      | "MeuCarroNovoPortalName"
      | "MobiAutoPortalName"
      | "OlxPortalName"
      | "ResourcesPortalName"
      | "MotorMePortalName"
      | "UsadosbrPortalName"
      | "SyncCmsPortalName"
      | "CarroSP"
      | "ChavesNaMao"
      | "Platforms"
      | "SoCarrao"
      | "RepasseAutos"
      | "Youtube"
      | "Cockpit"
      | "NaPistaLeads"
      | "SalaoDoCarro"
      | "CompreCarPortalLeads"
      | "ClickAutos"
      | "NetMotors"
      | "AutoShopping"
      | "ChavesNaMaoPortalLeads"
      | "ClickAutosPortalLeads"
      | "Premium";
    vendorId?: number;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/portals/remove-inconsistency",
      query: {
        portalCode: portalCode,
        vendorId: vendorId,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public updateCachedPortalPlans(): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/portals/update-cached-portal-plans",
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public updateCachedVersions(): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/portals/update-cached-versions",
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public updateCachedVersionsForPortal({
    portalCode,
  }: {
    portalCode:
      | "WebMotorsPortalName"
      | "AutolinePortalName"
      | "CompreCarPortalName"
      | "FacebookPortalName"
      | "iCarrosPortalName"
      | "MercadoLivrePortalName"
      | "MeuCarroNovoPortalName"
      | "MobiAutoPortalName"
      | "OlxPortalName"
      | "ResourcesPortalName"
      | "MotorMePortalName"
      | "UsadosbrPortalName"
      | "SyncCmsPortalName"
      | "CarroSP"
      | "ChavesNaMao"
      | "Platforms"
      | "SoCarrao"
      | "RepasseAutos"
      | "Youtube"
      | "Cockpit"
      | "NaPistaLeads"
      | "SalaoDoCarro"
      | "CompreCarPortalLeads"
      | "ClickAutos"
      | "NetMotors"
      | "AutoShopping"
      | "ChavesNaMaoPortalLeads"
      | "ClickAutosPortalLeads"
      | "Premium";
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/portals/update-cached-versions-for-portal",
      query: {
        portalCode: portalCode,
      },
    });
  }
}
